import { useState } from 'react';
import { styled } from '@mui/material/styles';
import Divider, { dividerClasses } from '@mui/material/Divider';
import Menu from '@mui/material/Menu';
import MuiMenuItem from '@mui/material/MenuItem';
import { paperClasses } from '@mui/material/Paper';
import { listClasses } from '@mui/material/List';
import ListItemText from '@mui/material/ListItemText';
import ListItemIcon, { listItemIconClasses } from '@mui/material/ListItemIcon';
import LogoutRoundedIcon from '@mui/icons-material/LogoutRounded';
import MoreVertRoundedIcon from '@mui/icons-material/MoreVertRounded';
import MenuButton from './MenuButton';

import SidePanel from "@component/SidePanel";
import MyAccountForm from '@component/MyAccountForm';

import { useLogoutMutation } from '@mutation/authMutation';

import { useTranslation } from "react-i18next";

const MenuItem = styled(MuiMenuItem)({
  margin: '2px 0',
});

export default function OptionsMenu() {
  const [anchorEl, setAnchorEl] = useState(null);
  const [detailPanelOpen, setDetailPanelOpen] = useState(false);
  const logoutMutation = useLogoutMutation();

  const { t } = useTranslation("main", "account");

  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleMyAccountPress = () => {
    handleClose();
    setDetailPanelOpen(true);
  }

  const handleDetailPanelClose = () => {
    setDetailPanelOpen(false);
    // adminAccountListQuery.refetch();
  };

  const handleLogout = () => {
    logoutMutation.mutate();
  };
  return (
    <>
      {/* Side Panel for Viewing/Updating my Account */}
      <SidePanel width={438} maxWidth={438} minWidth={360} open={detailPanelOpen} onClose={handleDetailPanelClose} title={t('account:myAccountDetails')}>
        <MyAccountForm />
      </SidePanel>
      

      {/* Option menu */}
      <MenuButton
        aria-label="Open menu"
        onClick={handleClick}
        sx={{ borderColor: 'transparent' }}
      >
        <MoreVertRoundedIcon />
      </MenuButton>
      <Menu
        anchorEl={anchorEl}
        id="menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        sx={{
          [`& .${listClasses.root}`]: {
            padding: '4px',
          },
          [`& .${paperClasses.root}`]: {
            padding: 0,
          },
          [`& .${dividerClasses.root}`]: {
            margin: '4px -4px',
          },
        }}
      >
        <MenuItem onClick={handleMyAccountPress}>
          {t("myAccount")}
        </MenuItem>
        <Divider />
        <MenuItem
          onClick={handleLogout}
          sx={{
            [`& .${listItemIconClasses.root}`]: {
              ml: 'auto',
              minWidth: 0,
            },
          }}
        >
          <ListItemText>
            {t("logout")}
          </ListItemText>
          <ListItemIcon>
            <LogoutRoundedIcon fontSize="small" />
          </ListItemIcon>
        </MenuItem>
      </Menu>
    </>
  );
}
